<template>
  <base-draggable-modal
      name="project_management_answers"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="project_management_answers">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <base-table-project-management-answers ref="base_table_project_management_answers" :current_tab="current_tab" :answers="answers" @refresh="$emit('refresh')"/>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseTableProjectManagementAnswers from "./BaseTableProjectManagementAnswers";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["current_tab", "answers"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    BaseTableProjectManagementAnswers,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      page: helpFunctions.pages.projectmanagementanswers,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('project_management_answers');
    },
    save() {
      this.$refs.base_table_project_management_answers.save();
      setTimeout(() => {
        this.$emit('refresh');
      }, 3000);
    },
    reset() {
      this.$emit('refresh');
      this.closeModal('project_management_answers')
    },
  },
};
</script>